import React, { Component } from 'react';
import Meta from "../Meta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ImageRender from "./ImageRender";
import { applyLang } from "../../../i18n";
import Loader from "../loader";
import Link from "next/link";
import { Trans } from "@lingui/react/macro";
import renderIcon from "../../../components/renderIcon";
import { ASSET_URL } from "../../../config";
import { formatDayjs } from "../../../services/localeFormat";


export default class GalerieImages extends Component {

    render() {
        const context = this.props.context;
        const { org, config, data } = context;

        const galerie = applyLang(data[0], context.lang);

        const title = galerie.name;
        const description = galerie.description;
        const image = galerie.bgImage ? `${ASSET_URL}/${galerie.bgImage}` : null;

        return (
            <div className="travel-page travel-page--galerie">
                <Meta context={context} title={title} description={description} image={image} />
                {this.props.loading && <Loader />}
                <Header context={context} />

                <main className="travel-main" id="main">
                    <header className="tr-galerie__header">
                        {context.render !== "embed" && <nav className="tr-galerie__crumb">
                            <Link href={org.BASE_WEB_URL + "/galeries"} legacyBehavior>
                                <a className="tr-galerie__crumb-link">
                                    {renderIcon({ name: "IconArrowLeft", source: "tabler" }, 14)}
                                    <span><Trans>Toutes les galeries</Trans></span>
                                </a>
                            </Link>
                        </nav>}

                        <h1 className="tr-galerie__title">{title}</h1>

                        {description && (
                            <p className="tr-galerie__subtitle">{description}</p>
                        )}

                        {galerie.datetime && (
                            <div className="tr-galerie__meta">
                                {renderIcon({ name: "IconCalendar", source: "tabler" }, 14)}
                                <span>{formatDayjs(galerie.datetime, context.langValue, "dddd DD MMMM YYYY")}</span>
                            </div>
                        )}
                    </header>

                    <div className="travel-container">
                        <ImageRender context={context} galerie={galerie} />
                    </div>
                </main>

                <style dangerouslySetInnerHTML={{ __html: `
                    .tr-galerie__header {
                        text-align: center;
                        padding: clamp(24px, 4vw, 48px) clamp(16px, 4vw, 32px) 16px;
                        max-width: 820px;
                        margin: 0 auto;
                    }
                    .tr-galerie__crumb {
                        margin-bottom: 14px;
                    }
                    .tr-galerie__crumb-link {
                        display: inline-flex;
                        align-items: center;
                        gap: 6px;
                        font-size: 13px;
                        color: var(--primary, #1b579e);
                        text-decoration: none;
                        font-weight: 500;
                        padding: 6px 12px;
                        border-radius: 999px;
                        background: color-mix(in srgb, var(--primary, #1b579e) 8%, white);
                        transition: background .15s;
                    }
                    .tr-galerie__crumb-link:hover {
                        background: color-mix(in srgb, var(--primary, #1b579e) 14%, white);
                    }
                    .tr-galerie__title {
                        margin: 0;
                        font-size: clamp(24px, 4vw, 40px);
                        font-weight: 800;
                        color: #1a1a2e;
                        line-height: 1.15;
                        letter-spacing: -.01em;
                        text-wrap: balance;
                    }
                    .tr-galerie__subtitle {
                        margin: 10px auto 0;
                        font-size: 16px;
                        color: #6b7280;
                        line-height: 1.5;
                        max-width: 640px;
                    }
                    .tr-galerie__meta {
                        margin-top: 14px;
                        display: inline-flex;
                        align-items: center;
                        gap: 6px;
                        font-size: 13px;
                        color: #6b7280;
                    }
                `}} />

                <Footer context={context} />
            </div>
        );
    }
}
